import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { prestashop } from "@/lib/platforms-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/platformy/prestashop";

export const Route = createFileRoute("/platformy/prestashop")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenia PrestaShop — moduły, integracje, optymalizacja | SyncTech",
      description:
        "Wdrożenia, migracje i rozwój sklepów PrestaShop. Moduły dedykowane, integracje z Baselinker, ERP, marketplace, kurierzy. Optymalizacja SEO i wydajności. Bezpłatna konsultacja.",
      path: PATH,
    }),
  component: () => <PlatformPage data={prestashop} path={PATH} breadcrumbCategory="Platformy" />,
});
